import { Row, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppDispatch } from "../../redux/store";
import "./index.less";

type ConfirmationModalNotificationProps = {
  isOpen: boolean;
  onClose?: () => void;
  disableNotification: () => Promise<void> | void;
};

const ConfirmationModalNotificationComponent: React.FC<ConfirmationModalNotificationProps> = ({ isOpen, onClose, disableNotification }) => {
  const { t } = useTranslation();
  const [isStable, setIsStable] = useState(false);

  //NOTE: WAIT FOR COMPONENT TO BE FULLY RENDERED AND STABLE
  useEffect(() => {
    if (isOpen) {
      setIsStable(false);

      requestAnimationFrame(() => {
        setTimeout(() => {
          setIsStable(true);
        });
      });
    } else {
      setIsStable(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (!isStable) return;

    if (onClose) {
      onClose();
    }
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  const handleDisableClick = () => {
    if (!isStable) return;

    disableNotification();
  };

  const handleCancelClick = () => {
    if (!isStable) return;

    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="bottom-modal-overlay" onClick={handleOverlayClick}>
      <div className="bottom-modal-content" onClick={handleModalClick}>
        <Row className="w-full justify-content-center mt-10">
          <div className="header-icon-grey" onClick={handleCancelClick}></div>
        </Row>
        <div className="bottom-modal-header">
          <Typography.Text className="bottom-modal-title f-26">{t("confirmation-notification-modal-title")}</Typography.Text>
        </div>
        <div className="bottom-modal-body">
          <Typography.Text className="bottom-modal-description">{t("confirmation-notification-modal-description")}</Typography.Text>
          <button disabled={!isStable} className="bottom-modal-button" style={{ opacity: isStable ? 1 : 0.7 }} onClick={handleDisableClick}>
            <Typography.Text className="bottom-modal-button-title">{isStable ? t("yes-disable") : "Processing..."}</Typography.Text>
          </button>

          <button className="bottom-modal-cancel-button" onClick={handleCancelClick} style={{ opacity: isStable ? 1 : 0.7 }}>
            <Typography.Text className="bottom-modal-cancel-button-title">{t("cancel")}</Typography.Text>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModalNotificationComponent;
